import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import {
  applyTheme,
  readThemePreference,
  resolveEffectiveTheme,
  systemPrefersDark,
} from "./lib/preferences";
import { initSentry } from "./lib/sentry";
import "@fontsource-variable/heebo/index.css";
import "./ui/styles.css";

// Apply the saved display preference before React replaces index.html's tiny
// static boot mark, preventing a light/dark flash on a hard refresh.
applyTheme(resolveEffectiveTheme(readThemePreference(), systemPrefersDark()));
initSentry();

const root = document.getElementById("root");

if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
